/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePromotionPrioritiesRequestInner
 */
export interface UpdatePromotionPrioritiesRequestInner {
    /**
     * 
     * @type {number}
     * @memberof UpdatePromotionPrioritiesRequestInner
     */
    priority: number;
    /**
     * 
     * @type {string}
     * @memberof UpdatePromotionPrioritiesRequestInner
     */
    id: string;
}

/**
 * Check if a given object implements the UpdatePromotionPrioritiesRequestInner interface.
 */
export function instanceOfUpdatePromotionPrioritiesRequestInner(value: object): value is UpdatePromotionPrioritiesRequestInner {
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UpdatePromotionPrioritiesRequestInnerFromJSON(json: any): UpdatePromotionPrioritiesRequestInner {
    return UpdatePromotionPrioritiesRequestInnerFromJSONTyped(json, false);
}

export function UpdatePromotionPrioritiesRequestInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePromotionPrioritiesRequestInner {
    if (json == null) {
        return json;
    }
    return {
        
        'priority': json['priority'],
        'id': json['id'],
    };
}

export function UpdatePromotionPrioritiesRequestInnerToJSON(value?: UpdatePromotionPrioritiesRequestInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'priority': value['priority'],
        'id': value['id'],
    };
}

